import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BadgeComponent } from './components/badge/badge.component';
import { BadgeModule } from 'primeng/badge';

@NgModule({
  imports: [
    CommonModule, 
    BadgeModule,
  ],
  declarations: [BadgeComponent],
  exports: [BadgeComponent],
})
export class SharedUiBadgesModule {}
